<div class="container">

  <div class="title sectiontitle">Assuré</div>
  <div class="flexrow ">
    <span class="title">NIR</span><span class="value">{{ empreinteCV.numSecu }}</span>
  </div>
  <div class="flexrow">
    <span class="title">Code Gestion AM</span><span class="value">{{ empreinteCV.codeGest }}</span>
  </div>

  <div class="title sectiontitle">Organisme AMO</div>
  <div class="flexrow">
    <span class="title">&nbsp;Régime AMO</span><span class="value">{{ empreinteCV.codeRegime }}</span>
  </div>
  <div class="flexrow">
    <span class="title">&nbsp;Caisse gest. AMO</span><span class="value">{{ empreinteCV.caisseGest }}</span>
  </div>
  <div class="flexrow">
    <span class="title">&nbsp;Centre gest. AMO</span><span class="value">{{ empreinteCV.centreGest }}</span>
  </div>

  <div class="title sectiontitle">AMO (AT défaut)</div>
  <div class="flexrow">
    <span class="title">&nbsp;Caisse gest. AT</span><span class="value">{{ empreinteCV.donneesAT?.orgaGestRisqueAT }}</span>
  </div>

  <div class="title sectiontitle">AMO (AT1)</div>
  <div class="flexrow">
    <span class="title">&nbsp;Caisse gest. AT1</span><span class="value">{{ empreinteCV.donneesAT?.orgaGestAT1 }}</span>
  </div>

  <div class="flexrow">
    <span class="title">&nbsp;ID AT1</span><span class="value">{{ empreinteCV.donneesAT?.idAT1 }}</span>
  </div>

  <div class="title sectiontitle">AMO (AT2)</div>
  <div class="flexrow">
    <span class="title">&nbsp;Caisse gest. AT2</span><span class="value">{{ empreinteCV.donneesAT?.orgaGestAT2 }}</span>
  </div>

  <div class="flexrow">
    <span class="title">&nbsp;ID AT2</span><span class="value">{{ empreinteCV.donneesAT?.idAT2 }}</span>
  </div>

  <div class="title sectiontitle">Bénéficiaire</div>

  <div class="flexrow ">
    <span class="title">Nom usuel</span><span class="value">{{ beneficiaire.nomUsuel }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Nom de famille</span><span class="value">{{ beneficiaire.nomFamille }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Prénom</span><span class="value">{{ beneficiaire.prenom }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">NIR certifié</span><span class="value">{{ beneficiaire.numSecuCertif }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Date certif. NIR</span><span class="value">{{ fselib.toFRformat(beneficiaire.dateCertifNumSecu) }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Date naissance</span><span class="value">{{ fselib.toFRformat(beneficiaire.dateNaissance) }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 1</span><span class="value">{{ beneficiaire.adresse1 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 2</span><span class="value">{{ beneficiaire.adresse2 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 3</span><span class="value">{{ beneficiaire.adresse3 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 4</span><span class="value">{{ beneficiaire.adresse4 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 5</span><span class="value">{{ beneficiaire.adresse5 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Qualité</span><span class="value">{{ beneficiaire.qualite }}</span>
  </div>

  <hr/>
  <div class="title open">Droits AMO ouverts</div>
  <hr/>

  @if (beneficiaire.codeSrvAMOBenef??'00' != '00') {
    <div>
      <div class="flexrow flex-justify">
        <div class="title">Service AMO spécifique</div>
        <div class="value">{{ beneficiaire.codeSrvAMOBenef }}&nbsp;{{ SituationSpecifiqueDescriptions[beneficiaire.codeSrvAMOBenef??'00'] }}</div>
      </div>
      @if (beneficiaire.dateDebSrvAMOBenef && beneficiaire.dateFinSrvAMOBenef) {
        <div class="flexrow">
          <span class="title">&nbsp;&nbsp;Dates Début/Fin</span><div class="flexrow aligncenter value">{{ (fselib.toFRformat(beneficiaire.dateDebSrvAMOBenef)?fselib.toFRformat(beneficiaire.dateDebSrvAMOBenef):'NR') }}<mat-icon>arrow_right</mat-icon>{{ (fselib.toFRformat(beneficiaire.dateFinSrvAMOBenef)?fselib.toFRformat(beneficiaire.dateFinSrvAMOBenef):'NR') }}</div>
        </div>
      }
    </div>
  }

  @if (false) {
    <!-- Test EV84 2.03 -->
    @for (pd of beneficiaire.periodeDroitsAMO; track pd; let i = $index) {
      <div [class.activeblock]="pd.active" class="situationblock">	<!-- Droits AMO -->
        <div class="flexrow flex-justify">
          <div class="title">Droits AMO</div>
        </div>
        <div class="flexrow">
          <span class="title">&nbsp;&nbsp;Dates Début/Fin</span><div class="flexrow aligncenter value">{{ (fselib.toFRformat(pd.dateDebut)?fselib.toFRformat(pd.dateDebut):'NR') }}<mat-icon>arrow_right</mat-icon>{{ (fselib.toFRformat(pd.dateFin)?fselib.toFRformat(pd.dateFin):'NR') }}</div>
        </div>
      </div>
    }
  }

  @for (pc of beneficiaire.periodeCodeCouverture; track pc; let i = $index) {
    <div [class.activeblock]="pc.active" class="situationblock">	<!-- Situations spécifiques -->
      <hr/>
      <div class="flexrow">
        <span class="title">Situation du patient</span><span class="value">{{ pc.codeSituation }}</span>
      </div>
      <div class="flexrow">
        <span class="title">&nbsp;&nbsp;Indicateur ALD</span><div class="value">{{ (pc.codeALD=='0'?'NON':'OUI') }}</div>
      </div>
      <div class="flexrow">
        <span class="title">&nbsp;&nbsp;Dates Début/Fin</span><div class="flexrow aligncenter value">{{ (fselib.toFRformat(pc.dateDebut)?fselib.toFRformat(pc.dateDebut):'NR') }}<mat-icon>arrow_right</mat-icon>{{ (fselib.toFRformat(pc.dateFin)?fselib.toFRformat(pc.dateFin):'NR') }}</div>
      </div>
    </div>
  }

  <hr/>

  @if (beneficiaire.donneesMutuelle) {
    <div class="title sectiontitle">Mutuelle an gestion unique</div>
    <div class="flexrow ">
      <span class="title">&nbsp;MUTNUM</span><span class="value">{{ beneficiaire.donneesMutuelle.mutnum }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Garanties</span><span class="value">{{ beneficiaire.donneesMutuelle.garanties }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Poss. Trait. TP</span><span class="value">{{ beneficiaire.donneesMutuelle.indicTraitMutuelle }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Type de service</span><span class="value">{{ beneficiaire.donneesMutuelle.typeService }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;N° AMC</span><span class="value">{{ beneficiaire.donneesMutuelle.service }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Aiguillage STS</span><span class="value">{{ beneficiaire.donneesMutuelle.aiguillageSTS }}</span>
    </div>
  }

  @if (beneficiaire.donneesAMC) {
    <div class="title sectiontitle">Mutuelle en gestion séparée</div>
    <div class="flexrow ">
      <span class="title">&nbsp;Id AMC</span><span class="value">{{ beneficiaire.donneesAMC.numAMC }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Id Adhérent</span><span class="value">{{ beneficiaire.donneesAMC.numAdherent }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Ind. Trait. AMC</span><span class="value">{{ beneficiaire.donneesAMC.indicTraitAMC }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Type de service</span><span class="value">{{ beneficiaire.donneesAMC.typeService }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Service</span><span class="value">{{ beneficiaire.donneesAMC.service }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Aiguillage STS</span><span class="value">{{ beneficiaire.donneesAMC.aiguillageSTS }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Code routage</span><span class="value">{{ beneficiaire.donneesAMC.codeRoutage }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Id Hôte</span><span class="value">{{ beneficiaire.donneesAMC.idHote }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Nom de domaine</span><span class="value">{{ beneficiaire.donneesAMC.domaine }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Date début</span><span class="value">{{ beneficiaire.donneesAMC.dateDebut }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Date fin</span><span class="value">{{ beneficiaire.donneesAMC.dateFin }}</span>
    </div>
  }

</div>